// extracted by mini-css-extract-plugin
export default {"banner":"BN","wrapper":"CN","selected_products":"EN","images":"FN","img":"GN","rounded_arrow":"HN","image-enter":"IN","image-enter-active":"JN","image-enter-done":"KN","image-exit":"LN","image-exit-active":"MN"};
    if(module.hot) {
      // 1714654894286
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  